const Login = () => import('@app/auth')
const ForgotPassword = () => import('./forgot-password')
const AcceptTerms = () => import('./accept-terms')
const NewAssignor = () => import('./new-assignor')
const NewPayer = () => import('./new-payer')
const ChangePassword = () => import('./change-password')
const RedirectLogin = () => import('./redirect-login')

export default [
  {
    path: '/auth/login',
    name: 'auth.login',
    component: Login,
    meta: { requiresAuth: false, transition: 'fade' }
  },
  {
    path: '/auth/redirect-login',
    name: 'auth.redirect-login',
    component: RedirectLogin,
    meta: { requiresAuth: false, transition: 'fade' }
  },
  {
    path: '/auth/forgot-password',
    name: 'auth.forgot-password',
    component: ForgotPassword,
    meta: { requiresAuth: false, transition: 'fade' }
  },
  {
    path: '/auth/change-password/:token',
    name: 'auth.change-password',
    component: ChangePassword,
    meta: { requiresAuth: false, transition: 'fade' }
  },
  {
    path: '/auth/new-assignor/:token',
    name: 'auth.new-assignor',
    component: NewAssignor,
    meta: { requiresAuth: false, transition: 'fade' }
  },
  {
    path: '/auth/accept-terms',
    name: 'auth.accept-terms',
    component: AcceptTerms,
    meta: { requiresAuth: true, transition: 'fade' }
  },
  {
    path: '/auth/new-payer/:token',
    name: 'auth.new-payer',
    component: NewPayer,
    meta: { requiresAuth: false, transition: 'fade' }
  }
]



// WEBPACK FOOTER //
// ./src/features/auth/routes.js